module.exports = __webpack_public_path__ + "img/levelup-icon-x.336ad990.svg";